export enum PolicyRuleEnum {
	PROGRESSIVE_BY_BRAND = "PROGRESSIVE_BY_BRAND",
	MINIMUM_AMOUNT_BY_BRAND = "MINIMUM_AMOUNT_BY_BRAND",
	REQUIRED_BASKET = "REQUIRED_BASKET",
	REQUIRED_PRODUCT = "REQUIRED_PRODUCT",
	REQUIRED_BRAND = "REQUIRED_BRAND",
	NOT_CONSIDERED_FOR_MINIMUM = "NOT_CONSIDERED_FOR_MINIMUM",
	MINIMUM_AMOUNT_BY_TABLE = "MINIMUM_AMOUNT_BY_TABLE"
}  